import { useEffect } from "react";
import Hero from "@/components/Hero";
import FreeBirthdayRide from "@/components/FreeBirthdayRide";
import PurchaseGuide from "@/components/PurchaseGuide";
import TrustBadges from "@/components/TrustBadges";
import TeaserCards from "@/components/TeaserCards";
import ReviewsHighlight from "@/components/ReviewsHighlight";
import CtaBand from "@/components/CtaBand";
import { setPageMeta } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    setPageMeta({
      title: "Cool Runnings Cape Town | Toboggan Family Park — Buy Online & Save 10%",
      description:
        "Africa's first downhill toboggan park — 1.25 km of track, up to 40 km/h, in Tygervalley, Cape Town. Open 7 days a week. Save 10% when you buy online. Solar powered, loadshedding-free.",
      image: "/og/home.jpg",
      keywords:
        "Cool Runnings, toboggan park Cape Town, downhill toboggan Cape Town, things to do in Cape Town with kids, family activities Cape Town, kids party venue Cape Town, Tygervalley attractions",
    });
  }, []);

  return (
    <>
      <Hero />
      <TeaserCards />
      <PurchaseGuide />
      <TrustBadges />
      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:pb-20">
        <FreeBirthdayRide />
      </section>
      <ReviewsHighlight />
      <CtaBand />
    </>
  );
}
